import React from 'react';
import './Input.css';

const Input = ({message, setMessage, sendMsg}) => {
    return (
        <form className="form">
            <input 
                className="input"
                type="text" 
                placeholder="Type a message..."
                value = {message} 
                onChange={(event)=>setMessage(event.target.value)} 
                onKeyPress={event=> event.key === 'Enter' && sendMsg(event)}
                />
            <button className="sendButton" onClick={event => sendMsg(event)}>Send</button>
        </form>
    );
};

export default Input;